import { Avatar, Box, Stack, Typography, gridClasses } from '@mui/material';
import { DataGrid } from '@mui/x-data-grid';
import React, { useEffect, useMemo, useState } from 'react'
import { useValue } from '../../../context/ContextProvider';
import { getUsers } from '../../../actions/user';
import moment from 'moment/moment';
import UserActions from './UserActions';

const GestionUsuarios = () => {
    /* To Do: Cambiar este modelo de permisos por uno que controle el servidor */
    const permisos = ['superusuario', 'administrador'];
    const [rowId, setRowId] = useState(null);
    const { state: { contextLoading, currentUser, users }, dispatch } = useValue();

    useEffect(() => {
        //console.log('useEffect GestionUsuarios: ')
        if (users?.length === 0 && currentUser) getUsers(0, currentUser, dispatch);
    }, [currentUser, contextLoading])

    const columns = useMemo(() => [
        {
            field: 'photoURL',
            headerName: 'Avatar',
            width: 80,
            renderCell: (params) => <Avatar src={params.row.photoURL} />,
            sortable: false,
            filterable: false,
        },
        { field: 'id', headerName: 'Id', width: 80 },
        { field: 'name', headerName: 'Nombre', width: 200, editable: true },
        { field: 'email', headerName: 'Email', width: 260, editable: true },
        {
            field: 'tipoUsuario',
            headerName: 'Rol',
            width: 120,
            type: 'singleSelect',
            valueOptions: ['cajero', 'administrador', 'superusuario'],
            editable: true,
        },
        {
            field: 'habilitado',
            headerName: 'Hab',
            width: 100,
            type: 'boolean',
            editable: true
        },
        {
            field: 'timestamp',
            headerName: 'Fecha',
            width: 100,
            renderCell: (params) => moment(params.row.timestamp).format('YYYY-MM-DD')
        },
        {
            field: 'actions',
            headerName: 'Acciones',
            type: 'actions',
            renderCell: (params) => <UserActions {...{ params, rowId, setRowId }} />
        }
    ], [rowId])

    function getRowId(row) {
        //console.log('Row Id', row.id);
        return row.id;
    }

    const handleEdit = (params) => {
        const newUsers = users.map((user) => user.id !== params.id ? user : params);
        //console.log({ newUsers });
        //dispatch({ type: 'UPDATE_USERS', payload: {rows: newUsers} });  //A users se envía el payload como {rows: valor}
        setRowId(params.id)
    }


    return (
        <Box bgcolor='white' display='flex' flex={12} padding={2} justifyContent='center'>
            <Box
                sx={{
                    height: '600px',
                    maxWidth: '1200px',
                }}
            >
                <Typography variant='h4' component='h3' sx={{ textAlign: 'center', mt: 3, mb: 3 }} >
                    Gestión de Usuarios
                </Typography>
                <DataGrid
                    columns={columns}
                    rows={users}
                    getRowId={getRowId}
                    onCellEditStop={(params) => handleEdit(params)}
                >
                </DataGrid>
            </Box>
        </Box>
    )
}

export default GestionUsuarios;